import React from "react";
import Stats from "./Stats";

export default function Hero() {
    return (
        <section className="text-center py-16 bg-[#C0EFC0]/25 gap-6">
            <h1 className="text-5xl font-bold">
                <div className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-[#202220] mb-2">AI-Powered Grant</div>
                <div className="text-[#212124]">
                    Writing Made Simple
                </div>
            </h1>
            <p className="py-6 text-xl text-gray-700">
                Leave the stress behind and step into success with a grant
                <div>writing partner
                    that's always ahead of the curve.
                </div>
            </p>
            <Stats />
            <div className="py-6 pb-12 flex justify-center">
                <button className="flex items-center gap-2 justify-center px-6 py-4 bg-primary text-sm text-white rounded-md w-[360px]">
                    <span className="material-icons">rocket</span>
                    <span>Get Started</span>
                </button>
            </div>
        </section>
    );
}
